module.exports = __webpack_public_path__ + "static/media/image_15.5835fff8.png";